import { Compass } from "lucide-react";

export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
        <Compass className="h-5 w-5 text-primary-foreground" />
      </div>
      <div className="flex flex-col">
        <span className="text-lg font-bold leading-tight">AcronIQ Veritus</span>
        <span className="text-xs text-muted-foreground leading-tight">Intelligence With Purpose</span>
      </div>
    </div>
  );
}
